/* eslint-disable @typescript-eslint/no-explicit-any */
import NotificationRequests from '~/repositories/notification';
import * as MessageService from '~/services/message';

import { NOTIFICATION_REPORT } from './actionTypes';

import { decreaseLoading, increaseLoading } from './loading';
import centralNavigationService from '~/services/navigation';

export const getNotifications =
  (searchParams: advancedFilterModels.baseFilter) => async (dispatch: any) => {
    dispatch(increaseLoading());
    try {
      const payload: models.PaginationResponse<models.Notification> =
        await NotificationRequests.getNotifications({
          ...searchParams,
          limit: searchParams.pageSize,
        });
      dispatch({
        payload,
        type: NOTIFICATION_REPORT,
      });
    } catch (err: any) {
      MessageService.error(err.message, { originalError: err });
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const createNotification = (params: any) => async (dispatch: any) => {
  dispatch(increaseLoading());
  try {
    await NotificationRequests.createNotification(params);
    MessageService.success(
      'PAGES.PANEL.PUSH_NOTIFICATIONS.DETAILS.SUCCESS_CREATE_MESSAGE'
    );
    centralNavigationService.back();
  } catch (err: any) {
    MessageService.error(err.message, { originalError: err });
  } finally {
    dispatch(decreaseLoading());
  }
};
